import React, {Component} from 'react';

export class HeadMenuNotLogin extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="">

                <div id="sidenav-left-login" className="sidenav">
                    <button onClick={this.props.onCloseNav} type="button"
                       className="btn btn-outline-secondary dropdown-item closebtn-sidenav" aria-label="Left Align">
                        <span className="las la-lg la-times" aria-hidden="true"/>{' '}
                    </button>
                    {/*<a href="javascript:void(0)" className="openbtn-sidenav" onClick={this.openNav}><span className="las la-bars"/></a>*/}
                    {/*<a onClick={this.props.onOpenNav} href="#" type="button"*/}
                    {/*   className="btn btn-outline-secondary dropdown-item openbtn-sidenav" aria-label="Left Align">*/}
                    {/*    <span className="las la-lg la-bars" aria-hidden="true"/>{' '}*/}
                    {/*</a>*/}
                    <button onClick={this.props.goBusqueda}  type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg" aria-hidden="true"/>{' '}
                    </button>
                    <hr/>

                    <button onClick={this.props.login}  type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-power-off" /*arisa-hidden="true"*/></span> Iniciar sesión
                    </button>
                    <hr/>

                    <button onClick={this.props.signUp}  type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-sign-in-alt"/> Registrar mi<br/> asociación/protectora
                    </button>
                    <hr/>

                    {/*<button onClick={this.props.contact} type="button"*/}
                    {/*   className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">*/}
                    {/*    <span className="las la-lg la-comment"></span> Contactar con soporte*/}
                    {/*</button>*/}
                    <a /*onClick={this.props.faqs}*/
                        href="/preguntas-frecuentes/?utm_source=buscador&utm_medium=menu"
                        target='_blank'
                        type="button" className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-question"></span> Preguntas frecuentes
                    </a>
                </div>
            </div>
        )
    }

    componentDidMount() {

        const that = this;
        $(document).mouseup(function (e) {
            const container = $('.sidenav');

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                that.props.onCloseNav()
            }
        });

    }

}